const data = () => {
    return {
        loading: false,
        initDate: generateDate(),
        finishDate: generateDate()
    };
};

function generateDate() {
    const f = new Date();
    return `${f.getFullYear()}-${pad(f.getMonth() + 1)}-${f.getDate()}`;
}

function pad(n) {
    return n < 10 ? `0${n}` : n;
}

export default data;
